module.exports = __webpack_public_path__ + "media/images/top/search/img_step02-e4d7304c7debdb5ee7fd074820436943.png";